import { graphql } from "api/cms-website/generated";

/** Strapi defaults relation to 10; request more for slider items. */
export const MultiColumnSliderFragment = graphql(/* GraphQL */ `
    fragment MultiColumnSliderFragment on ComponentComponentsMultiColumnSlider {
        id
        noMarginBottom
        multiColumnSliderTitle: title
        subtitle
        disclaimer
        items(pagination: { limit: 100 }) {
            ...BeforeAfterItemFragment
        }
        multiColumnSliderCta: cta {
            ...ButtonFragment
        }
        withExpansion
        mobileSwiper
    }
`);
